var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-dialog", {
    attrs: { icon: _vm.$MDI.Pencil, disabled: _vm.disabled },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [_vm._v("\n        Edit Motif\n    ")]
        },
        proxy: true,
      },
      {
        key: "toolbar-extra",
        fn: function () {
          return [
            _vm.motif.length > 0
              ? _c(
                  "v-icon",
                  {
                    staticStyle: { "margin-right": "16px" },
                    attrs: { title: "Clear" },
                    on: {
                      click: function ($event) {
                        _vm.motif = ""
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$MDI.Delete))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-icon",
              {
                on: {
                  click: function ($event) {
                    _vm.inSelection = false
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$MDI.CloseCircle))]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "text",
        fn: function () {
          return [
            _vm.motif
              ? _c("div", { staticClass: "mb-2" }, [
                  _vm._v(
                    "\n            Selected Motif:\n            " +
                      _vm._s(_vm.truncated) +
                      "\n            "
                  ),
                  _vm.error
                    ? _c(
                        "div",
                        {
                          staticClass: "v-alert v-alert--outlined error--text",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.error) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _c("div", { staticClass: "mb-2" }, [
                  _vm._v(
                    "\n            To choose a motif, click residues one at a time or click-and-drag to select a range.\n        "
                  ),
                ]),
            _vm._v(" "),
            _vm._l(_vm.chainMap, function (chain, key) {
              return _c("div", { staticStyle: { "margin-bottom": "1em" } }, [
                _c("h3", [_vm._v("Chain: " + _vm._s(key))]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "monospace",
                    on: { pointerup: _vm.onSpanPointerUp },
                  },
                  [
                    _vm._l((chain[0][1] % 10) - 1, function (i) {
                      return chain.length > 0 && chain[0][1] % 10 > 1
                        ? _c("span", { staticClass: "residue filler" }, [
                            _vm._v("\n                 \n                "),
                            _c("br"),
                            _vm._v("\n                 \n                "),
                            _c("br"),
                            _vm._v("\n                 \n            "),
                          ])
                        : _vm._e()
                    }),
                    _vm._l(chain, function (res) {
                      return _c(
                        "span",
                        {
                          staticClass: "residue selectable",
                          class: {
                            active:
                              key in _vm.active &&
                              _vm.active[key].includes(res[1]),
                          },
                          attrs: { "data-chain": key, "data-pos": res[1] },
                          on: {
                            click: function ($event) {
                              return _vm.toggleResidue(key, res[1])
                            },
                            selectstart: function ($event) {
                              return _vm.toggleSpanStart(key, res[1])
                            },
                            pointerenter: function ($event) {
                              return _vm.spanEnter(key, res[1])
                            },
                            pointerleave: function ($event) {
                              return _vm.spanLeave(key, res[1])
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "position" }, [
                            _vm._v(
                              _vm._s(
                                (_vm.highlight &&
                                  _vm.highlight.chain == key &&
                                  _vm.highlight.pos == res[1]) ||
                                  res[1] % 10 == 0
                                  ? res[1]
                                  : ""
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", { staticClass: "aa" }, [
                            _vm._v(_vm._s(res[2])),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", { staticClass: "ss" }, [
                            _vm._v(_vm._s(res[3] ? res[3] : " ")),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ])
            }),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.inSelection,
      callback: function ($$v) {
        _vm.inSelection = $$v
      },
      expression: "inSelection",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }